import { Environment } from '../../../environment';
import { Api } from '../axioscadastro';
import { v4 as uuidv4 } from 'uuid';

export interface IListagemProdutos {
   idprod: string,
   descricao: string,
   fabrica: string,
   valor: number,
  }
export interface IDetalheProdutos {
    descricao:string,
    ean:string,
    codfabrica:string,
    valor: number,
}
export interface IEtiquetas {
  descricao: string;
  ean: string;
  fabrica: string;
}
export interface IGeraCodigo {
  gerar_ean13: string;
}
type TotalCount = {
    data: IListagemProdutos[];
    totalCount: number;
}
const getAll = async (pagina = 1, filter = '', tipo: string): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/produtos?page=${pagina}&limit=${14}&filter=${filter}&tipo=${tipo}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] ||14),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const geracodigobarra = async (): Promise<IGeraCodigo | Error> => {
  try {
    const urlRelativa = `/geracodigobarra`;
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getById = async (id: string): Promise<IDetalheProdutos | Error> => {
  try {
    const { data } = await Api.get(`/produtos/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
}; 
const Etiquetas = async (tipo: string, idprod: string): Promise<IEtiquetas | Error> => {
  try {
    const urlRelativa = `/etiquetas?tipo=${tipo}&idprod=${idprod}`;
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
const create = async (dados: IDetalheProdutos): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheProdutos>('/produtos',  {idprod: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};
const updateById = async (id: string, dados: IDetalheProdutos): Promise<void | Error> => {
  try {
    await Api.put(`/produtos/${id}`, dados);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/produtos/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};
const getAllList = async (id = '', filter = '' ): Promise<TotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/produtoslist?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}` : `/produtoslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };}
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
export const ProdutosService = {
  getAll,
  geracodigobarra,
  create,
  getById,
  updateById,
  deleteById,
  getAllList,
  Etiquetas,
};